import { getRequest, postRequest } from './seviceHelpers';

/**
 * API requests starting with /monitors
 */
export default {
    // Getters
    getById: async id => getRequest(`/incidents/${id}?include=monitor,acknowledger`),
    getByHash: async hash => getRequest(`/ack/${hash}?include=monitor,acknowledger`),

    // Setters
    acknowledge: async id => postRequest(`/incidents/${id}/acknowledge`),
    acknowledgeHashed: async params => postRequest(
        `/ack/${params.incidentId}-${params.incidentHash}`,
        {
            data: {
                type: 'user',
                id: params.userId,
                meta: {
                    hash: params.userHash,
                },
            },
        },
    ),
};
